/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2019 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

@import '@spectrum/spectrum-variables/stylus/spectrum-light.styl'

:local(.root)
  display flex
  justify-content space-between
  min-width 350px
  padding-bottom 8px

:local(.copyLinkLabel)
  margin-bottom 0
  vertical-align -webkit-baseline-middle

:local(.copyLinkField)
  display flex
  margin-bottom 14px

  input
    flex-grow 1

    &.copied
      color $spectrum-global-color-blue400
